import { styled } from "@mui/material/styles";
import variables from "Styles/variables.scss";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import { Unstable_Popup as BasePopup } from "@mui/base/Unstable_Popup";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import {
  Box,
  Button,
  Chip,
  FormControlLabel,
  FormGroup,
  FormLabel,
  InputLabel,
  List,
  Modal,
  Select,
  Table,
  Tabs,
  TextField,
  AppBar,
  Badge,
  Avatar,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  CardContent,
  Card,
  Stack,
  DialogTitle,
  FormControl,
  DialogContent,
  StepLabel,
  RadioGroup,
  Radio,
  CardMedia,
  FormHelperText,
  TableCell,
  ListItemText,
  ListItemButton,
  TableRow
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import CategoryIcon from "@mui/icons-material/Category";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MuiDrawer from "@mui/material/Drawer";
import MuiChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import MuiChevronRightIcon from "@mui/icons-material/ChevronRight";
import Paper from "@mui/material/Paper";
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import Switch from "@mui/material/Switch";
import { CategoryOutlined, Home } from "@mui/icons-material";
import { NavLink } from "react-router-dom";
import SaveIcon from "@mui/icons-material/Save";

import { TimelineContent } from "@mui/lab";
// import { DataGrid } from "@mui/x-data-grid";

export const IconButtonDashboard = styled(IconButton)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? variables.colorWhite : variables.primary,
  padding: "6px"
}));
export const OutlineWhiteButton = styled(Button)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? variables.colorWhite : variables.primary,
  padding: "1px",
  border: "1px solid rgba(182, 182, 182, 0.4)",
  borderRadius: variables.borderRadius,
  fontWeight: variables.fontWeight400,
  fontSize: variables.defaultFontSize
}));

export const ButtonCheckbox = styled(FormGroup)(({ theme }) => ({
  ".MuiFormControlLabel-label": {
    padding: "6px 15px",
    border: "1px solid rgba(182, 182, 182, 0.4)",
    borderRadius: variables.borderRadius,
    width: "100%",
    fontSize: "0.75rem"
  },

  ".MuiCheckbox-root": {
    display: "none",
    visibility: "hidden",
    position: "absolute"
  },
  ".MuiCheckbox-root.Mui-checked + .MuiFormControlLabel-label": {
    background: variables.secondary
  },
  label: {
    marginLeft: 0,
    width: "100%",
    textAlign: "center"
  }
}));

export const ButtonCheckboxWithoutBG = styled(ButtonCheckbox)(({ theme }) => ({
  ".MuiFormControlLabel-label": {
    border: "2px solid rgba(182, 182, 182, 0.4)"
  },
  ".MuiCheckbox-root.Mui-checked + .MuiFormControlLabel-label": {
    background: "transparent",
    border: "2px solid",
    borderColor: variables.secondary
  }
}));

export const TableArrowIcon = styled(IconButton)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? variables.colorblack : variables.colorWhite,
  padding: "2px",
  background: theme.palette.mode === "dark" ? variables.colorWhite : variables.primary,
  borderRadius: variables.borderRadius,
  svg: {
    width: "1.2em",
    height: "1.2em"
  },
  ":hover": {
    color: theme.palette.mode === "dark" ? variables.colorWhite : variables.colorblack
  }
}));
export const TableDashboard = styled(Table)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? variables.colorWhite : variables.colorBlack,
  ".MuiTableCell-root": {
    borderColor: theme.palette.mode === "dark" ? variables.borderColor : variables.tableHeadColor,
    fontSize: variables.defaultFontSize,
    padding: "8px 16px 8px 8px"
  },
  ".MuiTableHead-root .MuiTableCell-root": {
    color: theme.palette.mode === "dark" ? variables.tableHeadColor : variables.colorBlack
  },
  ".MuiTableFooter-root  .MuiTableCell-footer": {
    color: theme.palette.mode === "dark" ? variables.colorWhite : variables.colorBlack
  }
}));
export const TableWithoutBorder = styled(TableDashboard)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? variables.colorWhite : variables.colorBlack,
  "tbody .MuiTableCell-root": {
    border: "none"
  }
}));
export const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? variables.boxDarkBg : variables.boxLightBg,
  backgroundImage: "none",
  ...theme.typography.body2,
  padding: "10px",
  textAlign: "left",
  color: theme.palette.mode === "dark" ? variables.colorWhite : variables.colorBlack,
  boxShadow: theme.palette.mode === "dark" ? "none" : variables.defaultBoxShadow,
  height: "100%",
  borderRadius: variables.borderRadius
}));

export const TabsDashboard = styled(Tabs)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? variables.colorWhite : variables.primary,
  minHeight: "30px",
  ".MuiButtonBase-root": {
    color: theme.palette.mode === "dark" ? variables.tabColor : variables.primary,
    paddingTop: "0",
    paddingBottom: "0",
    minHeight: "30px",
    fontWeight: variables.fontWeight400,
    borderBottom: "1px solid"
  },
  ".Mui-selected": {
    color: variables.secondary + "!important"
  },
  ".MuiTabs-indicator": {
    display: "none"
  }
}));

export const NewsList = styled(List)(({ theme }) => ({
  background: "transprent",
  paddingTop: 0,
  paddingBottom: 0,
  "li.MuiListItem-root": {
    paddingLeft: "0"
  },
  "li.MuiListItem-root p": {
    fontSize: variables.headingFontSize
  },
  "li.MuiListItem-root a": {
    fontSize: variables.headingFontSize,
    fontWeight: variables.fontWeight600
  }
}));
export const ATSDatePicker = styled(DatePicker)(({ theme }) => ({
  marginTop: "0px",
  width: "100%",
  // padding: "0px",
  fieldset: {
    borderColor: ""
  },
  ".MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
    border: "1px solid rgba(182, 182, 182, 0.4)"
  },

  // "&.MuiInputBase": {
  //   paddingTop: 0
  // },
  "& .MuiFormLabel-root": {
    "&.Mui-focused": {
      color: theme.palette.mode === "dark" ? variables.offWhite : `${variables.primary} !important`
    }
  },
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused fieldset": {
      borderColor:
        theme.palette.mode === "dark" ? variables.offWhite : `${variables.primary} !important`
    }
  },
  "&.MuiPickersPopper-root": {
    // padding: 0
  },
  ".MuiInputBase-input": {
    // padding: "8px 12px",
    // height: "2.4375em"
    // paddingTop: 0
  },
  "&.inside-modal .MuiInputBase-root": {
    background: variables.colorWhite,
    color: variables.colorblack
  },
  "&.inside-modal .MuiButtonBase-root svg": {
    fill: variables.colorblack
  },
  "&.inside-modal .Mui-disabled.MuiInputBase-root": {
    background: variables.tableHeadColor,
    borderRadius: variables.borderRadius
  },
  "&.inside-modal .Mui-disabled.MuiInputBase-root input": {
    WebkitTextFillColor: theme.palette.mode === "dark" ? variables.colorblack : variables.colorblack
  },
  ".MuiFormHelperText-root": {
    color: variables.colorRed,
    marginLeft: 0
  }
}));

export const ATSDateTimePicker = styled(DateTimePicker)(({ theme }) => ({
  marginTop: "24px",
  fieldset: {
    border: "1px solid rgba(182, 182, 182, 0.4)"
  },
  ".MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
    border: "1px solid rgba(182, 182, 182, 0.4)"
  },
  ".MuiInputBase-input": {
    padding: "8px 12px",
    height: "1.4375em"
  },
  "& .MuiFormLabel-root": {
    "&.Mui-focused": {
      color: theme.palette.mode === "dark" ? variables.offWhite : `${variables.primary} !important`
    }
  },
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused fieldset": {
      borderColor:
        theme.palette.mode === "dark" ? variables.offWhite : `${variables.primary} !important`
    }
  },
  "&.inside-modal .MuiInputBase-root": {
    background: variables.colorWhite,
    color: variables.colorblack
  },
  "&.inside-modal .MuiButtonBase-root svg": {
    fill: variables.colorblack
  },
  "&.inside-modal .Mui-disabled.MuiInputBase-root": {
    background: variables.tableHeadColor,
    borderRadius: variables.borderRadius
  },
  "&.inside-modal .Mui-disabled.MuiInputBase-root input": {
    WebkitTextFillColor: theme.palette.mode === "dark" ? variables.colorblack : variables.colorblack
  }
}));

export const PUCRadioGroup = styled(RadioGroup)(({ theme }) => ({
  "& .MuiFormLabel-root": {
    "&.Mui-focused": {
      color: theme.palette.mode === "dark" ? variables.offWhite : `${variables.primary} !important`
    }
  },
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused fieldset": {
      borderColor:
        theme.palette.mode === "dark" ? variables.offWhite : `${variables.primary} !important`
    }
  }
}));
export const PUCFormLabel = styled(FormLabel)(({ theme }) => ({
  "&.Mui-focused": {
    color: theme.palette.mode === "dark" ? variables.offWhite : `${variables.primary} !important`
  }
}));
export const PUCRadio = styled(Radio)(({ theme }) => ({
  "&.Mui-checked": {
    color: theme.palette.mode === "dark" ? variables.offWhite : `${variables.primary} !important`
  }
}));
export const ATSInput = styled(TextField)(({ theme }) => ({
  position: "relative",
  width: "100%",
  "label + &": {
    marginTop: theme.spacing(3)
  },
  "& .MuiFormLabel-root": {
    "&.Mui-focused": {
      color: theme.palette.mode === "dark" ? `${variables.primary} !important` : variables.offWhite
    }
  },
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused fieldset": {
      borderColor:
        theme.palette.mode === "dark" ? `${variables.primary} !important` : variables.offWhite
    }
  },
  "& .MuiInputBase-input": {
    padding: "6px 12px",
    borderRadius: 3,
    transition: theme.transitions.create(["border-color", "background-color", "box-shadow"]),
    fontSize: 12,
    border: "1px solid rgba(182, 182, 182, 0.4)",
    backgroundColor: "transprent",
    "&:focus": {
      boxShadow: `none`,
      borderColor: "1px solid rgba(182, 182, 182, 0.4)"
    },
    "&.Mui-disabled": {
      cursor: "no-drop"
    },
    "&:-webkit-autofill": {
      "-webkit-box-shadow": "0 0 0 100px transparent inset",
      "-webkit-text-fill-color": "#000",
      "caret-color": "#000"
    }
  },
  ".MuiFormHelperText-contained": {
    marginLeft: 0
  },
  ".MuiInputAdornment-root p": {
    color: theme.palette.mode === "dark" ? variables.colorWhite : variables.colorblack,
    marginTop: "2px"
  },
  ".Mui-readOnly": {
    WebkitTextFillColor:
      theme.palette.mode === "dark" ? variables.disabledColorDark : variables.disabledColorLight
  }
}));
export const ATSInputModal = styled(ATSInput)(({ theme }) => ({
  "& .MuiInputBase-input": {
    padding: "6px 12px",
    borderRadius: 3,
    transition: theme.transitions.create(["border-color", "background-color", "box-shadow"]),
    fontSize: 12,
    border: "1px solid rgba(182, 182, 182, 0.4)",
    backgroundColor: theme.palette.mode === "dark" ? variables.colorWhite : variables.colorWhite,
    color: theme.palette.mode === "dark" ? variables.colorblack : variables.colorblack,
    "&:focus": {
      boxShadow: `none`,
      borderColor: "1px solid rgba(182, 182, 182, 0.4)"
    }
  },
  "&.Mui-disabled": {
    background: variables.tableHeadColor
  },
  ".Mui-disabled": {
    background: variables.tableHeadColor,
    WebkitTextFillColor: theme.palette.mode === "dark" ? variables.colorblack : variables.colorblack
  }
}));

export const ATSInputLabel = styled(InputLabel)(({ theme }) => ({
  fontWeight: variables.fontWeight500,
  color: theme.palette.mode === "dark" ? variables.tableHeadColor : variables.colorblack,
  transition: "none",
  transform: "none",
  top: "7px"
}));

export const ATSModal = styled(Modal)(({ theme }) => ({
  ".MuiBox-root": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    background: theme.palette.mode === "dark" ? "#201A33" : variables.colorWhite,
    border: "1px solid #ACABAD",
    boxShadow: "none",
    padding: "0",
    borderRadius: variables.borderRadius,
    [theme.breakpoints.up("xs")]: {
      width: 300
    },
    [theme.breakpoints.up("md")]: {
      width: 500
    }
  },
  ".MuiModal-backdrop": {
    background: theme.palette.mode === "dark" ? "rgba(10, 3, 34, 0.9)" : "rgba(255, 255, 255, 0.9)"
  }
}));

/*
 ** Toggle customized design
 */

export const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)"
    }
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#1890ff"
      }
    }
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200
    })
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "rgba(255,255,255,.35)" : "rgba(0,0,0,.25)",
    boxSizing: "border-box"
  }
}));

//Chip Customization

export const ATSChips = styled(Chip)(({ theme }) => ({
  height: "22px",
  borderRadius: 8,
  ".MuiChip-label": {
    paddingLeft: "20px",
    paddingRight: "20px",
    fontWeight: variables.fontWeight500,
    fontSize: variables.defaultFontSize,
    lineHeight: 1
  }
}));

// custom form input

export const PucInput = styled(TextField)(({ theme }) => ({
  position: "relative",
  width: "100%",
  "label + &": {
    marginTop: theme.spacing(3)
  },
  "& .MuiFormLabel-root": {
    fontSize: variables.defaultFontSize,
    "&.Mui-focused": {
      color: theme.palette.mode === "dark" ? variables.offWhite : `${variables.primary} !important`
    }
  },

  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: ""
    },
    "&:hover fieldset": {
      borderColor: variables.tableHeadColor
    },
    "&.Mui-focused fieldset": {
      borderColor:
        theme.palette.mode === "dark" ? variables.offWhite : `${variables.primary} !important`
    }
  },
  "& .MuiInputBase-input": {
    borderRadius: 3,
    transition: theme.transitions.create(["border-color", "background-color", "box-shadow"]),
    fontSize: variables.defaultFontSize,
    borderStyle: "solid",
    backgroundColor: "transprent",
    "&:focus": {
      boxShadow: `none`,
      borderColor: "1px solid rgba(182, 182, 182, 0.4)"
    },
    "&.Mui-disabled": {
      cursor: "no-drop"
    },
    "&:-webkit-autofill": {
      "-webkit-box-shadow": "0 0 0 100px transparent inset",
      "-webkit-text-fill-color": "#000",
      "caret-color": "#000"
    }
  },
  ".MuiFormHelperText-contained": {
    marginLeft: 0
  },
  ".MuiInputAdornment-root p": {
    color: theme.palette.mode === "dark" ? variables.colorWhite : variables.colorblack,
    marginTop: "2px"
  },
  ".Mui-readOnly": {
    WebkitTextFillColor:
      theme.palette.mode === "dark" ? variables.disabledColorDark : variables.disabledColorLight
  }
}));

// custom button
export const PucButton = styled(Button)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? variables.colorblack : variables.btnColor,
  padding: "2px 24px",
  border: "1px solid",
  borderColor: variables.btnColor,
  borderRadius: variables.btnBorderRadius,
  fontWeight: variables.fontWeight600,
  fontSize: "0.64rem",
  backgroundColor: variables.colorWhite,

  "&:hover": {
    backgroundColor: variables.btnpreview,
    color: variables.colorWhite
  },
  "&:disabled": {
    color: theme.palette.mode === "dark" ? variables.colorblack : variables.tableHeadColor,
    opacity: 0.9
  }
}));

// custom fill button
export const PucFillButton = styled(Button)(({ theme }) => ({
  color: variables.colorWhite,
  padding: "14px 24px",
  backgroundColor: variables.fillBtnColor,
  borderRadius: variables.btnBorderRadius,
  fontWeight: variables.fontWeight600,
  fontSize: "0.64rem",

  "&:hover": {
    backgroundColor: "#c54e00"
  }
}));
export const PucFillAddButton = styled(Button)(({ theme }) => ({
  color: variables.colorWhite,
  padding: "10px 22px",
  backgroundColor: variables.fillBtnColor,
  borderRadius: "4px",
  fontWeight: variables.fontWeight600,
  fontSize: "0.64rem",

  "&:hover": {
    backgroundColor: "#c54e00"
  }
}));
export const PucFillPreviewButton = styled(Button)(({ theme }) => ({
  color: variables.colorWhite,
  padding: "14px 24px",
  backgroundColor: variables.btnpreview,
  borderRadius: variables.btnBorderRadius,
  fontWeight: variables.fontWeight600,
  fontSize: "0.64rem",

  "&:hover": {
    backgroundColor: variables.btnpreview,
    opacity: 0.95
  }
}));

export const PucFillLoginButton = styled(Button)(({ theme }) => ({
  color: variables.colorWhite,
  padding: "8px 24px",
  backgroundColor: variables.fillBtnColor,
  fontWeight: variables.fontWeight600,
  fontSize: "0.64rem",
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: "#c54e00"
  }
}));

// custom blue fill button
export const PucBlueFillButton = styled(Button)(({ theme }) => ({
  color: variables.colorWhite,
  padding: "14px 24px",
  backgroundColor: variables.primary,
  borderRadius: variables.btnBorderRadius,
  fontWeight: variables.fontWeight600,
  fontSize: "0.64rem",

  "&:hover": {
    backgroundColor: "#003F71"
  }
}));

// custom simple button
export const SimpleTextButton = styled(Button)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? variables.darkLinkColor : variables.primary,
  padding: "14px 4px",
  fontWeight: variables.fontWeight600,
  fontSize: "0.64rem"
}));

// custom select
export const PUCSelect = styled(Select)(({ theme }) => ({
  position: "relative",
  width: "100%",

  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: variables.offWhite
  },
  "& .MuiFormLabel-root": {
    fontSize: "0.64rem"
  },
  "& .MuiSelect-select-root": {
    borderColor: variables.offWhite
  },
  "& .MuiOutlinedInput-root": {
    "& .MuiSelect-outlined": {
      borderColor: variables.offWhite
    },
    "&:hover fieldset": {
      borderColor: ""
    },
    "&.Mui-focused fieldset": {
      borderColor: ""
    }
  },
  "& .MuiInputBase-input": {
    borderRadius: 3,
    transition: theme.transitions.create(["border-color", "background-color", "box-shadow"]),
    fontSize: 16,
    borderStyle: "solid",
    backgroundColor: "transprent",
    "&:focus": {
      boxShadow: `none`,
      borderColor: "1px solid rgba(182, 182, 182, 0.4)"
    },
    "&.Mui-disabled": {
      cursor: "no-drop"
    },
    "&:-webkit-autofill": {
      "-webkit-box-shadow": "0 0 0 100px transparent inset",
      "-webkit-text-fill-color": "#000",
      "caret-color": "#000"
    }
  },
  ".MuiFormHelperText-contained": {
    marginLeft: 0
  },
  ".MuiInputAdornment-root p": {
    color: theme.palette.mode === "dark" ? variables.colorWhite : variables.colorblack,
    marginTop: "2px"
  },
  ".Mui-readOnly": {
    WebkitTextFillColor:
      theme.palette.mode === "dark" ? variables.disabledColorDark : variables.disabledColorLight
  }
}));

export const PUCRadioLabel = styled(FormControlLabel)(({ theme }) => ({
  ".MuiFormControlLabel-label": {
    fontSize: variables.radioLabelFontSize,
    color: variables.radioLabel
  }
}));

export const PUCRadioHeadLabel = styled(FormLabel)(({ theme }) => ({
  color: variables.colorBlack
}));

const drawerWidth = 260;
const drawerWidthUser = 320;

export const PUCBox = styled(Box)(({ theme }) => ({
  background: theme.palette.mode === "dark" ? variables.darkBox : variables.colorWhite,
  position: "fixed",
  top: 0,
  left: 0,
  zIndex: 100,
  width: "100%"
  // borderBottom: `1px solid ${variables.grayColor}`
}));

export const PUCAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "open"
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,

  boxShadow: "none",
  padding: "0px 10px",
  display: "flex",
  justifyContent: "end",
  borderBottom: `1px solid ${variables.grayColor}`,
  backgroundColor: variables.colorWhite,
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  }),
  ...(!open && {
    marginLeft: `calc(${theme.spacing(6)} - 1px)`,
    width: `calc(100% - ${theme.spacing(6)} - 1px)`,
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${theme.spacing(11)} - 1px)`
    },
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  })
}));
export const PUCUserAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "open"
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,

  boxShadow: "none",
  padding: "0px 10px",
  display: "flex",
  justifyContent: "end",
  borderBottom: `1px solid ${variables.grayColor}`,
  backgroundColor: variables.colorWhite,
  ...(open && {
    marginLeft: drawerWidthUser,
    width: `calc(100% - ${drawerWidthUser}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  }),
  ...(!open && {
    marginLeft: `calc(${theme.spacing(6)} - 1px)`,
    width: `calc(100% - ${theme.spacing(6)} - 1px)`,
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${theme.spacing(11)} - 1px)`
    },
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  })
}));

export const PUCChevronLeftIcon = styled(MuiChevronLeftIcon)(({ theme }) => ({
  width: "32px",
  height: "32px",
  flexShrink: 0,
  borderRadius: "32px",
  border: `1px solid ${variables.grayColor}`,
  background: variables.colorWhite,
  color: variables.darkgray,
  cursor: "pointer",
  position: "absolute",
  left: "-1.06rem",
  bottom: "0.3rem"
}));

export const PUCChevronRightIcon = styled(MuiChevronRightIcon)(({ theme }) => ({
  width: "32px",
  height: "32px",
  flexShrink: 0,
  borderRadius: "32px",
  border: `1px solid ${variables.grayColor}`,
  background: variables.colorWhite,
  color: variables.darkgray,
  cursor: "pointer",
  position: "absolute",
  left: "-1.06rem",
  bottom: "0.3rem"
}));

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  border: "none",
  borderRight: `1px solid ${variables.grayColor}`,
  overflowX: "hidden"
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  overflowX: "hidden",
  border: "none",
  borderRight: `1px solid ${variables.grayColor}`,
  width: `calc(${theme.spacing(6)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(11)} + 1px)`
  }
});

const openedUserMixin = (theme) => ({
  width: drawerWidthUser,
  backgroundColor: "transparent",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  border: "none",
  // borderRight: `1px solid ${variables.grayColor}`,
  overflowX: "hidden"
});

const closedUserMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  backgroundColor: "transparent",
  overflowX: "hidden",
  border: "none",
  // borderRight: `1px solid ${variables.grayColor}`,
  width: `calc(${theme.spacing(6)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(11)} + 1px)`
  }
});
const openedUserCollapseMixin = (theme) => ({
  width: drawerWidthUser,
  backgroundColor: variables.colorWhite,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  border: "none",
  borderRight: `1px solid ${variables.grayColor}`,
  overflowX: "hidden"
});

const closedUserCollapseMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  backgroundColor: variables.colorWhite,
  overflowX: "hidden",
  border: "none",
  borderRight: `1px solid ${variables.grayColor}`,
  width: `calc(${theme.spacing(6)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(11)} + 1px)`
  }
});
export const PUCDrawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",

    ...(open && {
      ...openedMixin(theme),
      "& .MuiDrawer-paper": openedMixin(theme)
    }),
    ...(!open && {
      ...closedMixin(theme),
      "& .MuiDrawer-paper": closedMixin(theme)
    })
  })
);

export const PUCUserDrawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    width: drawerWidthUser,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",

    ...(open && {
      ...openedUserMixin(theme),
      "& .MuiDrawer-paper": openedUserMixin(theme)
    }),
    ...(!open && {
      ...closedUserMixin(theme),
      "& .MuiDrawer-paper": closedUserMixin(theme)
    })
  })
);
export const PUCUserCollapseDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open"
})(({ theme, open }) => ({
  width: drawerWidthUser,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",

  ...(open && {
    ...openedUserCollapseMixin(theme),
    "& .MuiDrawer-paper": openedUserCollapseMixin(theme)
  }),
  ...(!open && {
    ...closedUserCollapseMixin(theme),
    "& .MuiDrawer-paper": closedUserCollapseMixin(theme)
  })
}));

export const PUCDrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderBottom: `1px solid ${variables.grayColor}`,
  padding: theme.spacing(0, 1),

  // necessary for content to be below app bar
  ...theme.mixins.toolbar
}));
export const PUCUserDrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: variables.colorWhite,
  justifyContent: "center",
  minHeight: "65px ",
  padding: theme.spacing(0, 2),
  // borderRight: `1px solid ${variables.grayColor}`,
  borderBottom: `1px solid ${variables.grayColor}`,
  // necessary for content to be below app bar
  ...theme.mixins.toolbar
}));
export const PUCUserBox = styled(Box)(({ theme }) => ({
  backgroundColor: variables.colorWhite,
  paddingTop: "0.1rem",
  borderRadius: "12px",
  border: `1px solid ${variables.grayColor}`
}));
export const PUCCollapseUserBox = styled(Box)(({ theme }) => ({
  backgroundColor: variables.colorWhite,
  paddingTop: "0.1rem",
  borderRadius: "0px"
}));

export const PUCList = styled(List)(({ theme }) => ({
  padding: "16px 16px 16px 34px"
}));

export const PUCNotification = styled(NotificationsIcon)(({ theme }) => ({
  color: variables.darkgray,
  fontSize: "1rem"
}));
export const NavigateNotification = styled(Typography)(({ theme }) => ({
  cursor: "pointer",
  textDecoration: "underline",
  fontSize: "0.546875rem"
}));
export const QuantityValue = styled(Typography)(({ theme }) => ({
  padding: "0px 16px",
  fontSize: "0.546875rem"
}));
export const QuantityIncDecButton = styled(Typography)(({ theme }) => ({
  cursor: "pointer",
  color: "#034f81",
  fontSize: "0.546875rem"
}));
export const NotificationBox = styled(Box)(({ theme }) => ({
  overflow: "auto",
  height: "300px"
  // width: "400px"
}));
export const PUCNotificationBadge = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "20px",
  marginRight: "14px",
  cursor: "pointer"
}));

export const PUCBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    display: "flex",
    padding: "0px 6.5px",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "100px",
    background: variables.badgecolor
  }
}));

export const PUCAvatar = styled(Avatar)(({ theme }) => ({
  display: "flex",
  padding: "8px 12px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  borderRadius: "75px",
  border: `1px solid  #E8E9EC`,
  background: "#F8F8F8",
  color: "black",
  textAlign: "center",
  cursor: "pointer",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: "600",
  lineHeight: "normal"
}));

export const PUCTypography = styled(Typography)(({ theme }) => ({
  display: "flex",
  padding: "0px 7px",
  width: "100%",
  alignItems: "center",
  gap: "10px",
  justifyContent: "space-between",
  fontSize: "12px",
  alignSelf: "stretch",
  fontFamily: variables.fontFamily,
  color: variables.darkgray
}));
export const PUCListTypography = styled(Typography)(({ theme }) => ({
  display: "flex",
  // padding: "0px 7px",
  alignItems: "center",
  gap: "10px",
  fontSize: "14px",
  fontFamily: variables.fontFamily,
  borderRadius: "8px",
  fontWeight: variables.fontWeight400,
  width: "100%",
  alignSelf: "stretch",
  margin: "5px 0px",
  transition: "ease-in 0.1s",
  padding: "8px 8px 8px 12px",
  textDecoration: "none",
  color: variables.darkgray,
  "&:hover": {
    backgroundColor: variables.hoverColor,
    color: variables.hoverTextColor,
    fontWeight: variables.fontWeight600,
    transition: "ease-out 0.1s"
  },
  ".active &": {
    backgroundColor: variables.activecolor,
    color: variables.activecolortext,
    fontWeight: variables.fontWeight600,
    transition: "ease-out 0.1s"
  }
}));
export const PUCListLogoutTypography = styled(Typography)(({ theme }) => ({
  display: "flex",
  // padding: "0px 7px",
  alignItems: "center",
  gap: "5px",
  fontSize: "14px",
  fontFamily: variables.fontFamily,
  borderRadius: "8px",
  fontWeight: variables.fontWeight400,
  width: "100%",
  alignSelf: "stretch",
  cursor: "pointer",
  margin: "5px 0px",
  transition: "ease-in 0.1s",
  padding: "8px 8px 8px 12px",
  textDecoration: "none",
  backgroundColor: variables.colorWhite,
  color: variables.colorRed,
  "&:hover": {
    backgroundColor: variables.colorWhite,
    color: variables.colorRed,

    transition: "ease-out 0.1s"
  },
  ".active &": {
    backgroundColor: variables.colorWhite,
    color: variables.colorRed,

    transition: "ease-out 0.1s"
  }
}));

export const PUCListCollapseTypography = styled(Typography)(({ theme }) => ({
  display: "flex",
  // padding: "0px 7px",
  alignItems: "center",
  padding: "4px 13px",
  fontSize: "8px",

  flexDirection: "column",
  gap: "3px",
  whiteSpace: "break-spaces",
  textAlign: "center",

  fontFamily: variables.fontFamily,
  borderRadius: "8px",
  fontWeight: variables.fontWeight400,
  width: "100%",
  alignSelf: "stretch",
  margin: "5px 0px",
  transition: "ease-in 0.1s",
  textDecoration: "none",
  color: variables.darkgray,
  "&:hover": {
    backgroundColor: variables.hoverColor,
    color: variables.hoverTextColor,
    fontWeight: variables.fontWeight600,
    transition: "ease-out 0.1s"
  },
  ".active &": {
    backgroundColor: variables.activecolor,
    color: variables.activecolortext,
    fontWeight: variables.fontWeight600,
    transition: "ease-out 0.1s"
  }
}));
export const PUCListLogoutCollapseTypography = styled(Typography)(({ theme }) => ({
  display: "flex",
  // padding: "0px 7px",
  alignItems: "center",
  padding: "4px 13px",
  fontSize: "8px",

  flexDirection: "column",
  gap: "3px",
  whiteSpace: "break-spaces",
  textAlign: "center",
  cursor: "pointer",

  fontFamily: variables.fontFamily,
  borderRadius: "8px",
  fontWeight: variables.fontWeight400,
  backgroundColor: variables.colorWhite,
  color: variables.colorRed,
  width: "100%",
  alignSelf: "stretch",
  margin: "5px 0px",
  transition: "ease-in 0.1s",
  textDecoration: "none",

  "&:hover": {
    backgroundColor: variables.colorWhite,
    color: variables.colorRed,

    transition: "ease-out 0.1s"
  },
  ".active &": {
    backgroundColor: variables.colorWhite,
    color: variables.colorRed,

    transition: "ease-out 0.1s"
  }
}));
export const PUCFormButton = styled(Button)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? variables.colorWhite : variables.primary,
  border: `1px solid ${theme.palette.mode === "dark" ? variables.colorWhite : variables.primary}`,
  borderRadius: "50px",
  padding: "5px 10px",
  fontSize: "14px",
  gap: "5px"
}));
export const PUCExitApp = styled(ExitToAppIcon)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? variables.colorWhite : variables.primary,
  fontSize: "21px"
}));

export const PUCAccordion = styled(Accordion)(({ theme }) => ({
  boxShadow: "none",
  border: "none",
  margin: "0px 0px -5px!important",

  minHeight: "0px",
  "& .MuiPaper-root": {
    boxShadow: "none",
    border: "none",
    margin: "0px 0px",
    minHeight: "0px"
  },
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "2px", // Adjust the height as needed
    background: "transparent" // Replace with the desired color or styles
  }
}));
export const PUCUserAccordion = styled(Accordion)(({ theme }) => ({
  boxShadow: "none",
  border: "none",
  margin: "0px 0px -5px!important",
  borderTopLeftRadius: "12px!important",
  borderTopRightRadius: "12px!important",
  minHeight: "0px",
  "& .MuiPaper-root": {
    boxShadow: "none",
    border: "none",
    margin: "0px 0px",
    minHeight: "0px"
  },
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "2px", // Adjust the height as needed
    background: "transparent" // Replace with the desired color or styles
  }
}));
export const PUCUserBottomAccordion = styled(Accordion)(({ theme }) => ({
  boxShadow: "none",
  border: "none",
  // margin: "0px 0px -5px!important",
  borderBottomLeftRadius: "12px!important",
  borderBottomRightRadius: "12px!important",
  minHeight: "0px",
  "& .MuiPaper-root": {
    boxShadow: "none",
    border: "none",
    margin: "0px 0px",
    minHeight: "0px"
  },
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "2px", // Adjust the height as needed
    background: "transparent" // Replace with the desired color or styles
  }
}));

export const PUCAdminBox = styled(Box)(({ theme }) => ({
  display: "flex",

  flexDirection: "column",
  alignItems: "flex-start",
  gap: "0px",
  marginTop: "24px",
  height: "100%",
  borderRadius: "12px",
  padding: "24px",
  border: `1px solid ${variables.grayColor}`,
  background:
    theme.palette.mode === "dark" ? `${variables.darkBox} !important` : variables.colorWhite
}));

export const PUCUserPanelBox = styled(Box)(({ theme }) => ({
  padding: "24px",
  marginTop: "24px",
  height: "auto",
  width: "100%",
  borderRadius: "12px",
  border: `1px solid ${variables.grayColor}`,
  background:
    theme.palette.mode === "dark" ? `${variables.darkBox} !important` : variables.colorWhite
}));
export const PUCUserPanelTrackingBox = styled(Box)(({ theme }) => ({
  padding: "15px 0px",
  marginTop: "24px",
  height: "auto",
  width: "100%",
  borderRadius: "12px",
  border: `1px solid ${variables.grayColor}`,
  background:
    theme.palette.mode === "dark" ? `${variables.darkBox} !important` : variables.colorWhite
}));
export const PUCTimeLineBox = styled(Box)(({ theme }) => ({
  padding: "0px 0px 10px 10px"
}));

export const PUCAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  minHeight: "3px !important",

  "& .MuiAccordionSummary-content": {
    margin: "5px 0px !important",
    padding: "8px 0px 0px 0px "
  }
}));
export const PUCListItemText = styled(ListItemText)(({ theme }) => ({
  padding: "0px",
  paddingLeft: "0px",
  marginTop: "6px",
  marginBottom: "6px"
}));

export const PUCRemarkBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: "row",
  // marginTop: "10px",
  // marginBottom: "10px",
  flexWrap: "wrap"
}));
export const PUCRemarkTypography = styled(Typography)(({ theme }) => ({
  color: variables.primary,
  fontWeight: 600,
  fontSize: "10px",
  cursor: "pointer",
  borderBottom: `1px dashed ${variables.primary}`
}));
export const PUCViewMoreTypography = styled(Typography)(({ theme }) => ({
  color: variables.primary,
  textTransform: "capitalize",
  fontSize: "0.5rem",
  cursor: "pointer",
  gap: "10px"
}));
export const PUCMainViewMoreTypography = styled(Typography)(({ theme }) => ({
  wordBreak: "break-all",
  display: "flex",
  gap: "2px",
  justifyContent: "flex-start",
  alignItems: "center",
  flexDirection: "row",
  maxHeight: "100px",
  overflowY: "auto",
  flexWrap: "wrap",
  whiteSpace: "normal"
}));
export const PUCAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: "0px 10px"
}));

export const PUCCategoryIconActive = styled(CategoryIcon)(({ theme }) => ({
  //
}));
export const PUCCategoryIcon = styled(CategoryOutlined)(({ theme }) => ({
  //
}));

export const PUCHome = styled(HomeOutlinedIcon)(({ theme }) => ({}));
export const PUCHomeActive = styled(Home)(({ theme }) => ({}));
export const UploadBox = styled(Box)(({ theme }) => ({
  Width: "100%",
  minHeight: "170px",
  height: "auto",
  marginTop: "10px",
  marginBottom: "10px",
  borderRadius: "10px",
  border: "2px dashed",
  borderColor: theme.palette.mode === "dark" ? variables.uploadDarkBorderColor : variables.offWhite,
  backgroundColor: theme.palette.mode === "dark" ? variables.darkBox : variables.colorWhite,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column"
}));
export const UploadShopBox = styled(Box)(({ theme }) => ({
  Width: "100%",
  minHeight: "170px",
  height: "auto",
  marginTop: "10px",
  marginBottom: "10px",
  borderRadius: "10px",
  border: "2px dashed",
  borderColor: theme.palette.mode === "dark" ? variables.uploadDarkBorderColor : variables.offWhite,
  backgroundColor: theme.palette.mode === "dark" ? variables.darkBox : variables.colorWhite,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  alignItems: "center"
}));

export const LoginBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  minHeight: "calc(100vh - 80px)",
  margin: "0rem 2rem"
}));

export const LoginGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "white",
  width: "fit-content",
  paddingY: 5,
  minHeight: "100%",
  gap: "0px",
  border: "1px solid lightgray",
  paddingX: 4,
  borderRadius: "8px",
  justifyContent: "center",
  maxWidth: 475
}));

export const PUCNavLink = styled(NavLink)(({ theme }) => ({
  textDecoration: "none",

  "&:hover": {
    textDecoration: "underline"
  },

  "&.breadactive": {
    color: variables.fadeBlackColor,
    fontWeight: variables.fontWeight500
  },

  "&.breadnotactive": {
    color: variables.darkgray
  }
}));

export const PUCBreadActiveNavLink = styled(NavLink)(({ theme }) => ({
  textDecoration: "none",

  "&:hover": {
    textDecoration: "none"
  },
  "&.breadactive": {
    color: variables.fadeBlackColor,
    fontWeight: variables.fontWeight600,
    cursor: "text"
  },
  "&.breadnotactive": {
    color: variables.darkgray
  }
}));
export const PUCTimelineContent = styled(TimelineContent)(({ theme }) => ({
  padding: "6px 0px 16px 16px"
}));

export const PUCLabelTypography = styled(Typography)(({ theme }) => ({
  // color: variables.darkgray,
  // fontSize: "13px",
  minHeight: 1.7,
  display: "flex",
  cursor: "pointer",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%"
  // fontWeight: variables.fontWeight400,
  // letterSpacing: "1px",
  // textTransform: "uppercase"
}));
export const PUCHeadLabelTypography = styled(Typography)(({ theme }) => ({
  // color: variables.fadeBlackColor,
  // fontSize: "16px",
  // fontWeight: variables.fontWeight600,
  // letterSpacing: "1px",
  // textTransform: "capitalize"
}));

export const ImageBox = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${variables.grayColor}`,
  borderBottomLeftRadius: "0px",
  borderBottomRightRadius: "0px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "6rem",
  height: "6rem",
  borderRadius: "4px",
  color: variables.colorWhite
}));
export const ImageDescriptionBox = styled(Box)(({ theme }) => ({
  borderRadius: "4px",
  border: `1px solid ${variables.borderColor}`
}));

export const PUCCardContent = styled(CardContent)(({ theme }) => ({
  paddingBottom: "10px !important",
  "& .MuiCardContent-root": {
    paddingBottom: "10px !important"
  }
}));

export const PUCCardTypographyTitle = styled(Typography)(({ theme }) => ({
  marginBottom: "0px",
  fontSize: "16px",
  fontWeight: "400"
}));
export const PUCCardTypographysubTitle = styled(Typography)(({ theme }) => ({
  marginBottom: "0px",
  fontSize: "12px",
  fontWeight: "400"
}));
export const StatusTypography = styled(Typography)(({ theme }) => ({
  lineHeight: "40px"
}));

export const LoginSubGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column"
}));

export const PUCLoginSubTypography = styled(Typography)(({ theme }) => ({
  color: variables.colorGreyLight,
  fontSize: 14,
  mt: 0.5,
  textAlign: "center"
}));

export const PUCLocationButton = styled(Button)(({ theme }) => ({
  background: variables.fillBtnColor,
  color: variables.textColor,
  ":hover": {
    background: variables.fillBtnColor,
    color: variables.textColor
  }
}));
export const ItemSaveButton = styled(Button)(({ theme }) => ({
  background: "none",
  color: "none",
  ":hover": {
    background: "none",
    color: "none"
  }
}));
export const PUCEditButton = styled(Button)(({ theme }) => ({
  background: variables.primary,
  color: variables.textColor,
  padding: "5px 10px",
  ":hover": {
    background: variables.primary,
    color: variables.textColor
  }
}));
export const PUCPaymentButton = styled(Button)(({ theme }) => ({
  background: variables.approvedtxt,
  color: variables.textColor,
  padding: "5px 10px",
  ":hover": {
    background: variables.approvedtxt
  }
}));
export const PUCLeftAlignGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "15px",
  flexWrap: "wrap"
}));
export const RequestButton = styled(Button)(({ theme }) => ({
  background: variables.btnColor,
  color: variables.textColor,
  ":hover": {
    background: variables.btnColor,
    color: variables.textColor
  }
}));
export const PaymentRejectButton = styled(Button)(({ theme }) => ({
  // background: variables.fillBtnColor,
}));
export const PaymentCancelButton = styled(Button)(({ theme }) => ({
  // background: variables.fillBtnColor,
  background: "none",
  color: "#000",
  boxShadow: "none",

  ":hover": {
    background: "none",
    color: "#000",
    boxShadow: "none"
  }
}));
export const ListItemButtons = styled(ListItemButton)(({ theme }) => ({
  // background: variables.fillBtnColor,
  background: "none",
  boxShadow: "inset 0 0 2px #e8e9ec",
  padding: "0",
  ":hover": {
    background: "none",
    boxShadow: "inset 0 0 2px #e8e9ec"
  }
}));

export const PaymentImage = styled(Image)(({ theme }) => ({
  width: "50px"
}));

export const PUCFurnitureButton = styled(Button)(({ theme }) => ({
  background: variables.btnColor,
  color: variables.textColor,
  ":hover": {
    background: variables.btnColor,
    color: variables.textColor
  }
}));
export const PUCFurnitureBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",

  flexWrap: "wrap"
}));

export const PucFurnitureAddButton = styled(Button)(({ theme }) => ({
  color: variables.primary
}));
export const PUCRemoveCircleOutlineIcon = styled(RemoveCircleOutlineIcon)(({ theme }) => ({
  cursor: "pointer"
}));
export const PUCDeleteOutlineIcon = styled(DeleteOutlineIcon)(({ theme }) => ({
  cursor: "pointer"
}));
export const ClearText = styled(Typography)(({ theme }) => ({
  cursor: "pointer"
}));

export const PUCBoxSpace = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "left",
  gap: "20px",
  alignItems: "center",
  flexWrap: "wrap"
}));

export const PUCEditIcon = styled(EditIcon)(({ theme }) => ({
  cursor: "pointer",
  color: variables.pendingtxt
}));

export const PUCSaveIcon = styled(CheckCircleIcon)(({ theme }) => ({
  cursor: "pointer",
  color: variables.approvedtxt
}));
export const PUCSaveIconItem = styled(SaveIcon)(({ theme }) => ({
  cursor: "pointer",
  color: "#d55e0a"
}));
export const AmountTypography = styled(Typography)(({ theme }) => ({
  fontWeight: "500"
}));
export const LocationGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "16px"
}));
export const FurnitureGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "16px"
}));
export const PaymentGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "end",
  gap: "16px"
}));
export const PaymentTypography = styled(Typography)(({ theme }) => ({
  display: "flex",
  justifyContent: "start",
  alignItems: "center"
}));
export const PaymentOutlineCircle = styled(ErrorOutlineIcon)(({ theme }) => ({
  color: variables.radioLabel,
  fontSize: "20px"
}));

export const PUCCard = styled(Card)(({ theme }) => ({
  border: `1px solid ${variables.grayColor}`,
  cursor: "pointer"
}));

export const PUCAlignBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between"
}));
export const PUCDOCAlignBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  flexDirection: "column"
}));

export const ErrorHelpText = styled(FormHelperText)(({ theme }) => ({
  marginLeft: "0px"
}));
export const ErrorDOCHelpText = styled(FormHelperText)(({ theme }) => ({
  marginLeft: "5px",
  color: variables.rejectedtxt
}));

export const SearchTaleDataButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#034f81",
  color: "#ddf1fe",
  fontSize: "12px",
  marginLeft: "5px",
  "&:hover": {
    color: "#ddf1fe",
    backgroundColor: "#034f81"
  },
  "&:disabled": {
    color: variables.colorWhite
  }
}));
export const SearchLocationInput = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-input": {
    padding: "12px 16px"
  },
  "& .MuiInputBase-root": {
    paddingRight: "6px"
  }
}));
export const SearchLocationDataButton = styled(Button)(({ theme }) => ({
  backgroundColor: variables.grayColor,
  color: variables.fadeBlackColor,
  padding: "6px 16px",
  fontSize: "14px",
  marginLeft: "5px",
  "&:hover": {
    backgroundColor: variables.grayColor,
    color: variables.fadeBlackColor
  }
}));

export const TableContainer = styled(Box)(({ theme }) => ({
  height: "auto",
  width: "100%",
  boxShadow: "none"
}));
export const TableStack = styled(Stack)(({ theme }) => ({
  padding: "16px 0px",
  margin: "0 auto",
  cursor: "pointer"
}));

export const SearchInput = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-input": {
    padding: "9px 16px"
  },
  "& .MuiInputBase-root": {
    paddingRight: "6px"
  }
}));

export const TableSearchButton = styled(Button)(({ theme }) => ({
  color: variables.fadeBlackColor,
  fontSize: "15px"
}));

// export const PUCDataGrid = styled(DataGrid)(({ theme }) => ({
//   "&.MuiDataGrid-root": {
//     borderColor: variables.grayColor,
//     "& .MuiDataGrid-virtualScroller": {
//       overflowY: "overlay",
//       "&::-webkit-scrollbar": {
//         width: "7px !important",
//         height: "7px"
//       },
//       "&::-webkit-scrollbar-thumb": {
//         backgroundColor: `${variables.thumbBackground} !important`, // Adjust as needed
//         borderRadius: "4px !important"
//       },
//       "&::-webkit-scrollbar-track": {
//         backgroundColor: `${variables.trackBackground} !important`, // Adjust as needed
//         borderRadius: "4px !important",
//         padding: "4px"
//       }
//     }
//   },
//   "& .MuiDataGrid-withBorderColor": {
//     borderColor: variables.grayColor
//   },
//   "& .MuiDataGrid-columnHeaders": {
//     borderColor: variables.grayColor
//   },
//   "& .MuiDataGrid-columnHeaderTitle": {
//     color: variables.fadeBlackColor,
//     fontSize: "14px",
//     fontWeight: variables.fontWeight600
//   },
//   "& .MuiTablePagination-selectLabel": {
//     color: variables.darkgray,
//     fontSize: "12px",
//     fontWeight: variables.fontWeight400
//   },
//   "& .MuiInputBase-root": {
//     color: variables.fadeBlackColor,
//     fontSize: "12px",
//     fontWeight: variables.fontWeight400
//   },
//   "& .MuiTablePagination-displayedRows": {
//     color: variables.fadeBlackColor,
//     fontSize: "12px",
//     fontWeight: variables.fontWeight400
//   },
//   "& .MuiSvgIcon-root": {
//     fill: variables.darkgray
//   }
// }));

export const PUCDialogTitle = styled(DialogTitle)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center"
}));

export const PUCCloseIcon = styled(CloseIcon)(({ theme }) => ({
  cursor: "pointer"
}));

export const PUCABCloseIcon = styled(CloseIcon)(({ theme }) => ({
  cursor: "pointer",
  color: variables.colorWhite,
  backgroundColor: variables.rejectedtxt,
  borderRadius: "50%",
  padding: "5px",
  position: "absolute",
  right: "-12px",
  top: "-12px"
}));

export const PUCFormControl = styled(FormControl)(({ theme }) => ({
  margin: "4px"
}));

export const PUCAlignGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "end",
  gap: "10px"
}));
export const PUCGrid = styled(Grid)(({ theme }) => ({
  padding: "12px",
  margin: "24px 0px 16px 24px",
  position: "relative",
  border: `1px solid ${variables.grayColor}`,
  borderRadius: "12px"
}));

export const PUCSubGrid = styled(Grid)(({ theme }) => ({
  padding: "12px"
}));
export const ItemGrid = styled(Grid)(({ Grid }) => ({
  marginBottom: "20px"
}));

export const PUCDeleteIcon = styled(DeleteIcon)(({ theme }) => ({}));

export const PUCAddIcon = styled(AddIcon)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? `${variables.colorWhite} !important` : variables.primary
}));
export const ListButton = styled(Button)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? `${variables.colorWhite} !important` : variables.primary
}));
export const UploadSubShopBox = styled(Box)(({ theme }) => ({
  display: "inline-block",
  width: "100%",
  maxHeight: "100%",
  "& :hover": {
    opacity: 1
  }
}));

export const PUCFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  marginRight: "28px"
}));
export const PUCRoleRadioGroup = styled(RadioGroup)(({ theme }) => ({
  paddingLeft: "40px",
  gap: "40px",
  "& .MuiFormLabel-root": {
    "&.Mui-focused": {
      color: theme.palette.mode === "dark" ? variables.offWhite : `${variables.primary} !important`
    }
  },
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused fieldset": {
      borderColor:
        theme.palette.mode === "dark" ? variables.offWhite : `${variables.primary} !important`
    }
  }
}));
export const ViewCardMedia = styled(CardMedia)(({ theme }) => ({
  height: "94px",
  objectFit: "cover"
}));
export const ViewPreviewImage = styled(CardMedia)(({ theme }) => ({
  height: "auto",
  objectFit: "cover"
}));
export const PUCDocBox = styled(Box)(({ theme }) => ({
  padding: "0px 16px"
}));
export const PUCDocAlignBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center"
}));
export const ViewDocCardMedia = styled(CardMedia)(({ theme }) => ({
  height: "70px",
  width: "70px",
  objectFit: "contain",
  borderRight: `1px solid ${variables.offWhite}`
}));
export const ViewPDFCardMedia = styled(CardMedia)(({ theme }) => ({
  height: "70px",
  width: "70px",
  objectFit: "contain",
  padding: "10px",
  borderRight: `1px solid ${variables.offWhite}`
}));

export const ViewPaymentDoc = styled(CardMedia)(({ theme }) => ({
  height: "70px",
  width: "70px",
  objectFit: "contain",
  borderRight: `1px solid ${variables.offWhite}`,
  marginRight: "20px"
}));
export const ViewPreviewImg = styled(CardMedia)(({ theme }) => ({
  height: "94px",
  objectFit: "contain"
}));
export const ErrorChip = styled(Chip)(({ theme }) => ({
  color: "red",
  background: "unset",
  paddingLeft: "0px"
}));

export const PUCAdminActionBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
  alignItems: "flex-end"
}));
export const PUCAdminTemplateBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
  alignItems: "flex-end",
  marginTop: "50px"
}));
export const PUCCancel = styled(Button)(({ theme }) => ({
  color: variables.fadeBlackColor
}));

export const PUCTextAdornment = styled(Typography)(({ theme }) => ({
  color: `${variables.textAndorement}!important`
}));

export const PUCDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: "24px 24px 32px 24px"
}));

export const PUCStepLabel = styled(StepLabel)(({ theme }) => ({
  ".Mui-active": {
    color:
      theme.palette.mode === "dark"
        ? `${variables.colorWhite} !important`
        : `${variables.primary} !important`
  },
  ".Mui-completed": {
    color:
      theme.palette.mode === "dark"
        ? `${variables.colorWhite} !important`
        : `${variables.primary} !important`
  }
}));

export const PUCUserStepLabel = styled(StepLabel)(({ theme }) => ({
  ".MuiStepLabel-iconContainer": {
    ".Mui-active": {
      color:
        theme.palette.mode === "dark"
          ? `${variables.colorWhite} !important`
          : `${variables.primary} !important`
    },

    ".Mui-completed": {
      color:
        theme.palette.mode === "dark"
          ? `${variables.colorWhite} !important`
          : `${variables.primary} !important`
    },
    ".MuiSvgIcon-root": {
      width: "10px",
      height: "10px",
      marginLeft: "7px",
      ".MuiStepIcon-text": {
        fill: "none"
      }
    }
  },
  ".MuiStepLabel-labelContainer": {
    ".Mui-active": {
      color:
        theme.palette.mode === "dark"
          ? `${variables.colorWhite} !important`
          : `${variables.colorBlack} !important`
    },
    ".MuiStepLabel-label": {
      color: variables.colorBlack
    },
    ".Mui-completed": {
      color:
        theme.palette.mode === "dark"
          ? `${variables.colorWhite} !important`
          : `${variables.colorBlack} !important`
    }
  }
}));
export const PUCUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          "#fff"
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be"
      }
    }
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.palette.mode === "dark" ? "#003892" : "#001e3c",
    width: 32,
    height: 32,
    "&::before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        "#fff"
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`
    }
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
    borderRadius: 20 / 2
  }
}));

export const PUCBoxWrapper = styled(Box)(({ theme }) => ({
  background:
    theme.palette.mode === "dark"
      ? `${variables.colorWhite} !important`
      : `${variables.primary} !important`
}));
export const PUCTableContainer = styled(TableContainer)(({ theme }) => ({
  border: `1px solid ${variables.offWhite}`,
  borderRadius: "5px"
}));
export const Homebox = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  gap: "24px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center"
}));
export const HomeSubBox = styled(Box)(({ theme }) => ({
  textAlign: "center"
}));

export const PopupBody = styled("div")(
  ({ theme }) => `
  width: max-content;
  height: auto;
  
  padding: 16px;
  margin: 8px;
  border-radius: 8px;
  border: 1px solid ${variables.offWhite};
  background-color: ${variables.colorWhite};
  box-shadow: 
   0px 4px 8px rgb(0 0 0 / 0.1);
  z-index: 1;
`
);
export const PUCBasePopup = styled(BasePopup)(({ theme }) => ({
  zIndex: 1000000
}));
export const LogoutTypography = styled(Typography)(({ theme }) => ({
  display: "flex",
  marginTop: "0.2rem",
  cursor: "pointer"
}));
export const RowGrid = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row"
}));
export const PUCTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: `1px solid ${variables.grayColor}`
}));
export const PUCTableCellQuantity = styled(TableCell)(({ theme }) => ({
  borderBottom: `1px solid ${variables.grayColor}`,
  display: "flex",
  // justifyContent: "center",
  alignItems: "center",
  height: "104px",
  marginBottom: "-1px"
}));
export const PUCTableRowTotalAmount = styled(TableRow)(({ theme }) => ({
  borderBottom: `1px solid ${variables.grayColor}`
  // display: "flex",
  // justifyContent: "center",
  // alignItems: "center",
  // height: "84px",
  // marginBottom:"-1px"
}));
export const PUCKeyboardArrowUpIcon = styled(KeyboardArrowUpIcon)(({ theme }) => ({
  fontSize: "0.8rem",

  color: variables.darkgray
}));

export const PUCKeyboardArrowDownIcon = styled(KeyboardArrowDownIcon)(({ theme }) => ({
  fontSize: "0.8rem",

  color: variables.darkgray
}));

export const PUCExpandCircleUPOutlinedIcon = styled(ExpandCircleDownOutlinedIcon)(({ theme }) => ({
  transform: "rotate(180deg)"
  // color:"#fff"
}));
export const ButtonViewMore = styled(Button)(({ theme }) => ({
  color: "#000000de",
  border: "1px solid #e8e9ec",
  background: "#1976d20a",
  "&:hover": {
    border: "1px solid #e8e9ec"
  }
}));

export const PucOptions = styled(Button)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? variables.colorblack : variables.btnColor,
  padding: "2px 24px",
  border: "1px solid",
  borderColor: variables.btnColor,
  fontWeight: variables.fontWeight600,
  fontSize: "0.56rem",
  backgroundColor: variables.colorWhite,
  minHeight: "60px",
  width: "100%",
  // "&:hover": {
  //   backgroundColor: variables.btnpreview,
  //   color: variables.colorWhite
  // },
  "&:disabled": {
    color: theme.palette.mode === "dark" ? variables.colorblack : variables.tableHeadColor,
    opacity: 0.9
  }
}));

export const FormHeadingTypography = styled(Typography)(({ theme }) => ({
  fontSize: "22px",
  marginBottom: "24px",
  fontWeight: "600"
}));
export const MessageTypography = styled(Typography)(({ theme }) => ({
  fontSize: "12px",
  lineBreak: "-moz-initial"
}));
export const PUCNotificationContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  right: "32%",
  zIndex: 10000000,
  top: "8%"
}));

export const PUCNotificationBox = styled(Box)(({ theme }) => ({
  minWidth: "50%",
  maxHeight: "700px",
  border: "1px solid #adad97",
  borderRadius: "10px",
  // position: "absolute",
  // left: "67%",
  // top: "12%",
  boxShadow: "0px 0px 5px",
  backgroundColor: variables.colorWhite,
  width: "450px"
}));

export const PUCNotificationBar = styled(Box)(({ theme }) => ({
  backgroundColor: variables.activecolor,
  padding: "5px",
  display: "flex",
  justifyContent: "space-between"
}));
export const BodyContainer = styled(Box)(({ theme }) => ({
  overflowY: "scroll"
  //  height:"100vh",
  //  overflow:"hidden"
}));
export const FormHeading = styled(Typography)(({ theme }) => ({
  margin: "0px 0px 20px 0px",
  fontWeight: "600",
  fontSize: "24px"
}));

export const PUCNotificationBarTypography = styled(Box)(({ theme }) => ({
  backgroundColor: variables.activecolor,
  padding: "5px",
  color: variables.activecolortext,
  fontSize: variables.defaultFontSize
}));

// Notification custom styles

export const NotificationHeading = styled(Typography)(({ theme }) => ({
  fontSize: "12px",
  color: "#5D616D",
  display: "block"
}));
export const NotificationHeadingTime = styled(Typography)(({ theme }) => ({
  fontSize: "12px",
  color: "#5D616D",
  display: "block",
  paddingRight: "24px",
  paddingTop: "16px"
}));
export const UnreadMessageBox = styled(Grid)(({ theme }) => ({
  borderLeft: "4px solid #034F81",
  background: "#DDF1FE",
  paddingLeft: "24px",
  cursor: "pointer",
  borderBottom: `1px solid ${variables.grayColor}`
}));
export const ReadMessageBox = styled(Grid)(({ theme }) => ({
  paddingLeft: "24px",
  cursor: "pointer"
}));
export const notipaginationBox = styled(Typography)(({ theme }) => ({
  width:"100%",
  display: "flex",
  justifyContent: "end",
  alignItems: "center",
}));
